
import { Component, Mixins } from 'vue-property-decorator';
import { ListingFilter, ListingOrderBy } from 'client-website-ts-library/filters';
import { View } from 'client-website-ts-library/plugins';
import { WebsiteLevel } from 'client-website-ts-library/types';
import { API } from 'client-website-ts-library/services';

import Listings from '../components/Listings.vue';
import ListingSearch from '../components/ListingSearch.vue';

@Component({
  components: {
    Listings,
    ListingSearch,
  },
})
export default class OfficePropertiesForRent extends Mixins(View) {
  private listingFilter: ListingFilter | null = null;

  handleFilter(filter: ListingFilter) {
    const id = this.$route.params.id;
    if (id) {
      API.Slugs.Resolve(id).then((resolved) => {
        if (resolved.Type === 'Office') {
          // City
          if (resolved.Id === '91b553f9-7cbc-4697-bf7d-d70714b674a4') {
            // eslint-disable-next-line no-param-reassign
            filter.SearchLevel = WebsiteLevel.Office;
            // eslint-disable-next-line no-param-reassign
            filter.SearchGuid = '29d9080e-165e-4372-afc4-374f5b90fdde';
          }

          // Redlynch
          if (resolved.Id === 'f2c947c3-1b35-41ce-8380-54f0ff32cd52') {
            // eslint-disable-next-line no-param-reassign
            filter.SearchLevel = WebsiteLevel.Office;
            // eslint-disable-next-line no-param-reassign
            filter.SearchGuid = '4e9814df-12f6-4c08-b411-1499c2b952c9';
          }
        }
        // eslint-disable-next-line no-param-reassign
        filter.OrderByStatements = [ListingOrderBy.CreateDateDesc];
        this.listingFilter = filter;
      });
    } else {
      // eslint-disable-next-line no-param-reassign
      filter.OrderByStatements = [ListingOrderBy.CreateDateDesc];
      this.listingFilter = filter;
    }
  }
}
